import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { isNumber } from 'lodash';

import * as services from 'modules/user/services/updateUser';
import { SUBMIT_EDIT_USER_FORM } from '../editUser';
import createAction from '../';

export const UPDATE_USER = createAsyncAction(createAction('UPDATE_USER'));

export const updateUser = (userData) => (dispatch) => {
  dispatch({ type: UPDATE_USER.pending });

  const apiCallParams = {
    mutation: services.UPDATE_USER,
    variables: {
      policyId: userData.policyId || '',
      firstName: userData.firstName || '',
      middleName: userData.middleName || '',
      lastName: userData.lastName || '',
      email: userData.email || '',
      phoneNumber: userData.phoneNumber || '',
      title: userData.title || '',
      address: userData.address || '',
      description: userData.description || '',
      avatar: userData.avatar || '',
      dateOfBirth: userData.dateOfBirth || isNumber(userData.dateOfBirth) ? `${ userData.dateOfBirth }` : '',
      gender: userData.gender ? userData.gender : null,
    },
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(({ data: { updateUser: user } }) => {
      return dispatch({
        type: UPDATE_USER.success,
        payload: user.profile,
        user,
      });
    })
    .catch((err) => {
      dispatch({ type: UPDATE_USER.failure });
      dispatch({ type: SUBMIT_EDIT_USER_FORM.failure });
      throw err;
    });
};
